export const timePeriods = {
  1: '1 Day',
  3: '3 Days',
  5: '5 Days',
  7: '7 Days',
};
